<template>
  <div class="tankuang">
    <div class="mask"></div>
    <!--登录弹框-->
    <div class="login-pop" id="login-pop">
      <div class="close-pop close">
        <img src="../../assets/img/close2.png" alt>
      </div>
      <div class="account">
        <p>修改密码</p>
        <p></p>
        <div class="form">
          <div class="row">
            <span class="bphone">当前账户名: <span v-text="phoneAnnot"></span></span>
          </div>
          <div class="row">
            <input :type="typea" placeholder="设置旧密码（6-16位）" class="pass" v-model="oldPass" v-on:input ="getBtn">
            <label :class="{'active':isActivea}">
              <i class="iconfont icon-guanbi-" style="float:left" @click="oldPassNull"></i>
              <span class="pass-show iconfont" @click="showPassa"></span>
            </label>
          </div>
          <div class="row">
            <input :type="typeb" placeholder="设置新密码（6-16位）" class="pass" v-model="newPass" v-on:input ="getBtn">
            <label :class="{'active':isActiveb}">
              <i class="iconfont icon-guanbi-" style="float:left" @click="newPassNull"></i>
              <span class="pass-show iconfont" @click="showPassb"></span>
            </label>
          </div>
          <p v-if="ispassword" class="warning" v-text="isWrong"></p>
        </div>
        <div :class='["look-more",a==0?"active":""]' @click="getVerify">验证</div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  data() {
    return {
      phone: '',
      oldPass:'',
      newPass:'',
      phoneAnnot:'',
      code:'',
      isSend: "发送验证码",
      typea: "password",
      typeb: "password",
      isActivea: false,
      isActiveb: false,
      ispassword:false,
      isWrong:'请输入6-16位数字字母组合密码!',
      a: 0 
    };
  },
  mounted() {
    this.getData();
    const self = this;
    $(".close-pop").click(function() {
      self.$parent.$data.panelModal = false 
    });
  },
  methods: {
    getBtn() {
      if (this.oldPass != "" && this.newPass != "") {
        this.a = 1;
      } else {
        this.a = 0;
      }
    },
    oldPassNull(){
      this.oldPass = ''
    },
    newPassNull(){
      this.newPass = ''
    },
    showPassa() {
      this.isActivea = !this.isActivea;
      if (this.isActivea == true) {
        this.typea = "text";
      } else {
        this.typea = "password";
      }
    },
    showPassb() {
      this.isActiveb = !this.isActiveb;
      if (this.isActiveb == true) {
        this.typeb = "text";
      } else {
        this.typeb = "password";
      }
    },
    showPass() {
      this.isActive = !this.isActive;
      if (this.isActive == true) {
        this.type = "text";
      } else {
        this.type = "password";
      }
    },
    getData() {  //获取手机号
      this.$http
        .get("/api/user/013-getUserInfoById", {
          params: {
            id: this.$store.state.userInfo.id
          }
        })
        .then(res => {
          console.log(res);
          if (res.status == 200 && res.data.code == 0) {
            this.phoneAnnot = res.data.rows[0].nickName
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getVerify(){  //设置密码
      if (!this.common.verifyPass(this.oldPass)|| !this.common.verifyPass(this.newPass)) {          
          this.ispassword = true;
          return false;
      }else{
          this.ispassword = false;
      }
       this.$http
        .get("/api/user/005-changepassword", {
          params: {
            token:this.$store.state.userInfo.token,
            oldPwd: this.oldPass,
            newPwd: this.newPass
          }
        })
        .then(res => {
          console.log(JSON.stringify(res));
          if (res.status == 200 && res.data.code == 0) {
            this.$message('修改成功')
            setTimeout(() => {
              this.$parent.$data.panelModal = false
            },300)
          }
          if(res.status == 200 && res.data.code == 1006 ){
               this.isWrong = res.data.msg;
               this.ispassword = true;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
  }
};
</script>
<style scoped>
.look-more {
  cursor: pointer;
}
.look-more.active {
  border: none;
  background: #ededed;
  color: #fff;
  pointer-events: none;
  cursor: not-allowed;
}
.login-pop{top:40%;}
.login-pop .account {
  margin-top: 35px;
}
.login-pop .account .form .row {
  height: 50px;
}
.login-pop .account .form .row input,
.login-pop .account .form .row label,
.login-pop .account .form .row .code {
  margin-top: 0px;
}
.login-pop .account .look-more {
  margin-top: 45px;
}
.look-more.active {
  border: none;
  background: #ededed;
  color: #fff;
}
.login-pop .account .form .row label i {
  float: right;
}
.login-pop .account {
  height:410px;
}
.bphone {
  font-weight: normal;
  line-height: 50px;
  margin: 0px;
  float: left;
  color: #010101;
  font-size: 16px;
}
@media (min-width: 640px) and (max-width: 719px){
  .login-pop{top:35%;}
}
@media (min-width: 415px) and (max-width: 639px){
.login-pop{top:25%;}
}
@media (min-width: 320px) and (max-width: 414px){
.login-pop{top:0%;}
.login-pop .account{height:365px;border-radius: 6px}
}
</style>